import { apiSlice } from "../api/apiSlice";

export const videoApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllVideos: builder.query({
            query: () => ({
                url: "/videos",
                method: "GET",
            }),   
        }),

        postVideo: builder.mutation({
            query: (data) => ({
                url: "/videos",
                method: "POST",
                body: {...data,createdAt: new Date(),views:`${data.views}K`},
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    if(result?.data?.id){

                      
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllVideos", undefined,
                                (draft) => {
                    
                                  return  draft.push(arg)
                                }
                                ))
                                
                            }


                    

                   
                } catch (err) {
                    // do nothing
                }
            },
          
        }),
        updateVideo: builder.mutation({
            query: ({id,data}) => ({
                url: `/videos/${id}`,
                method: "PATCH",
                body: {...data,createdAt: new Date(),views:`${data.views}K`},
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    
                    
                    
                    if (result?.data?.id) {
                  
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllVideos", undefined,
                                (draft) => {
                                  
                                    const draftQuiz = draft.find(
                                        (c) => c.id == arg.id
                                    );
                                  
    
                                
                                    draftQuiz.title = arg.data.title;
                                    draftQuiz.url = arg.data.url;
                                    draftQuiz.views = arg.data.views;
                                    draftQuiz.duration = arg.data.duration;
                                    draftQuiz.description = arg.data.description;

                                }
                            ))
                    }




                } catch (err) {
                    // do nothing
                }
            },
        }),
        deleteVideo: builder.mutation({
            query: (id) => ({
                url: `/videos/${id}`,
                method: "DELETE",
            
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {


                // optimistic cache update start
              
                // optimistic cache update end
                try {
                  const result = await queryFulfilled;
           
                  if(result?.meta?.response?.status==200){
                    dispatch(
                        apiSlice.util.updateQueryData(
                          "getAllVideos", undefined,
                          (draft) => {
                         
                            draft.splice(draft.findIndex(t=>t.id==arg),1);
                        
              
                          }
                        )
                      );
                  }
        
                } catch (err) {
                 
                }
              },
          
        }),
        
        getVideo: builder.query({
            query: (id) => ({
                url: `/videos/${id}`,
                method: "GET",
            }),   
        }),
    }),
});

export const { useGetAllVideosQuery,useGetVideoQuery,usePostVideoMutation ,useUpdateVideoMutation,useDeleteVideoMutation } = videoApi;